import client from './api-client';

export const serviceGetCfgFormAumentoConciliar = async (query) => {
    try {
        const response = await client.get(`cfg-forms?q=${query}`);
        if (response.status === 200 && response.data.code === 1) return response.data.object;
        else throw new Error(response.data.message);
    } catch (error) {
        throw error;
    }
}

export const serviceGetSolicitudAumentoConciliar = async (query) => {
    try {
        const response = await client.get(`gestion-implicado/aumento-conciliar?q=${query}`);
        if (response.status === 200 && response.data.code === 1) return response.data.object;
        else throw new Error(response.data.message);
    } catch (error) {
        throw error;
    }
}

export const serviceGetHistorialAumentoConciliar = async (query) => {
    try {
        const response = await client.getImplicado(`getion-implicado/aumento-conciliar?q=${query}`);
        if (response.status === 200 && response.data.code === 1) return response.data.object;
        else throw new Error(response.data.message);
    } catch (error) {
        throw error;
    }
}

export const serviceGetDetalles = async (query) => {
    try {
        const response = await client.get(`detalles?q=${query}`);
        if (response.status === 200 && response.data.code === 1) return response.data.object;
        else throw new Error(response.data.message);
    } catch (error) {
        throw error;
    }
}

export const servicePostRespuestaAumentoConciliar = async (body) => {
    try {
        const response = await client.post('gestion-implicado/aumento-conciliar', body);
        return response.data;
    } catch (error) {
        throw error;
    }
}
